export const convertTimeToLocal = {
  methods: {
    convertTimeToLocal(timeString = '00:00:00', offset = 3.5) {
      const hours = parseInt(timeString.split(':')[0])
      const minutes = parseInt(timeString.split(':')[1])
      const seconds = '00'

      // Create a Date object with the parsed time (assuming local time)
      const localDate = new Date(2024, 4, 24, hours, minutes, seconds) // Year, Month (0-indexed), Day, Hours, Minutes, Seconds

      localDate.setHours(localDate.getHours() + 3)
      localDate.setMinutes(localDate.getMinutes() + 30)

      const newHours = localDate.getHours().toString().padStart(2, '0')
      const newMin = localDate.getMinutes().toString().padStart(2, '0')

      return `${newHours}:${newMin}:00`
    },
  },
}
